import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'relements/build/esm/ui/icon';
import HelperUtils from '@haptik/helpers/build/esm/platformUtils';
import EntityV2 from 'relements/build/esm/ui/icons/EntityV2';
import BotResponses from 'relements/build/esm/ui/icons/BotResponses';

function BotSaysHeaderDefault({
  title,
  onToggle,
  toggled,
  DOMRef,
  tooltip,
  iconType,
  noArrow,
}) {
  const toggledClassName = toggled ? 'toggled' : '';

  const getIcon = () => {
    switch (iconType) {
      case 'EntityV2':
        return <EntityV2 marginRight="4px" />;
      default:
        if (!iconType) return <BotResponses marginRight="4px" />;
        return (
          <Icon
            src={iconType || 'bot-says-colored'}
            className="bot-says-card-header-row-icon"
          />
        );
    }
  };

  return (
    <div
      className="bot-says-card-header"
      ref={DOMRef}
      onClick={noArrow ? undefined : onToggle}
    >
      <div
        className="bot-says-card-header-row"
        style={{ cursor: noArrow ? 'default' : 'pointer' }}
      >
        {getIcon()}
        <div className="bot-says-card-header-row-title">{title}</div>
        {tooltip.text ? (
          <Icon
            prefixClassName="addLabelTooltip"
            src="info"
            tooltip={
              <div>
                <span
                  dangerouslySetInnerHTML={{
                    __html: HelperUtils.htmlEscape(tooltip.text),
                  }}
                />
                {tooltip.url ? (
                  <a
                    href={tooltip.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {' '}
                    Learn More
                  </a>
                ) : null}
              </div>
            }
          />
        ) : null}
        {noArrow ? null : (
          <div className="bot-says-card-header-row-cta">
            <Icon
              onClick={onToggle}
              src="angle-down"
              className={`bot-says-card-header-row-cta-icon ${toggledClassName}`}
              tooltip={!toggled ? 'Expand' : 'Collapse'}
            />
          </div>
        )}
      </div>
    </div>
  );
}

BotSaysHeaderDefault.propTypes = {
  title: PropTypes.string,
  onToggle: PropTypes.bool,
  toggled: PropTypes.bool,
  DOMRef: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // Or the instance of a DOM native element (see the note about SSR)
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  iconType: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  noArrow: PropTypes.bool,
  tooltip: PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string,
  }),
};

BotSaysHeaderDefault.defaultProps = {
  title: '',
  DOMRef: null,
  iconType: '',
  onToggle: false,
  toggled: false,
  noArrow: false,
  tooltip: {
    text: '',
    url: '',
  },
};

export default BotSaysHeaderDefault;
